"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatsbeatInstrumentationMap = exports.StatsbeatInstrumentation = exports.StatsbeatFeature = exports.APPLICATIONINSIGHTS_SDKSTATS_DISABLED = exports.AzureMonitorSampleRate = exports.DEFAULT_LIVEMETRICS_ENDPOINT = exports.DEFAULT_BREEZE_ENDPOINT = exports.BROWSER_SDK_LOADER_DEFAULT_SOURCE = exports.AttachTypePrefix = exports.APPLICATION_INSIGHTS_SHIM_VERSION = exports.AZURE_MONITOR_AUTO_ATTACH = exports.AZURE_MONITOR_PREFIX = exports.AZURE_MONITOR_STATSBEAT_FEATURES = exports.AZURE_MONITOR_OPENTELEMETRY_VERSION = exports.StatsbeatFeaturesMap = void 0;
/**
 * Statsbeat Features Mapping
 * @internal
 */
exports.StatsbeatFeaturesMap = new Map([
    ["diskRetry", 1],
    ["aadHandling", 2],
    ["browserSdkLoader", 4],
    ["distro", 8],
    ["liveMetrics", 16],
    ["shim", 32],
    ["customerSdkStats", 64],
    ["multiIkey", 128],
]);
exports.AZURE_MONITOR_OPENTELEMETRY_VERSION = "1.16.0";
exports.AZURE_MONITOR_STATSBEAT_FEATURES = "AZURE_MONITOR_STATSBEAT_FEATURES";
exports.AZURE_MONITOR_PREFIX = "AZURE_MONITOR_PREFIX";
exports.AZURE_MONITOR_AUTO_ATTACH = "AZURE_MONITOR_AUTO_ATTACH";
exports.APPLICATION_INSIGHTS_SHIM_VERSION = "APPLICATION_INSIGHTS_SHIM_VERSION";
var AttachTypePrefix;
(function (AttachTypePrefix) {
    AttachTypePrefix["INTEGRATED_AUTO"] = "i";
    AttachTypePrefix["MANUAL"] = "m";
})(AttachTypePrefix || (exports.AttachTypePrefix = AttachTypePrefix = {}));
/**
 * Default Browser SDK Loader Source
 * @internal
 */
exports.BROWSER_SDK_LOADER_DEFAULT_SOURCE = "https://js.monitor.azure.com/scripts/b/ai";
/**
 * Default Breeze endpoint.
 * @internal
 */
exports.DEFAULT_BREEZE_ENDPOINT = "https://dc.services.visualstudio.com";
/**
 * Default Live Metrics endpoint.
 * @internal
 */
exports.DEFAULT_LIVEMETRICS_ENDPOINT = "https://global.livediagnostics.monitor.azure.com";
/**
 * Internal attribute name for sample rate
 * @internal
 */
exports.AzureMonitorSampleRate = "microsoft.sample_rate";
/**
 * Disables customer-facing SDK Stats.
 * @internal
 */
exports.APPLICATIONINSIGHTS_SDKSTATS_DISABLED = "APPLICATIONINSIGHTS_SDKSTATS_DISABLED";
var StatsbeatFeature;
(function (StatsbeatFeature) {
    StatsbeatFeature[StatsbeatFeature["NONE"] = 0] = "NONE";
    StatsbeatFeature[StatsbeatFeature["DISK_RETRY"] = 1] = "DISK_RETRY";
    StatsbeatFeature[StatsbeatFeature["AAD_HANDLING"] = 2] = "AAD_HANDLING";
    StatsbeatFeature[StatsbeatFeature["BROWSER_SDK_LOADER"] = 4] = "BROWSER_SDK_LOADER";
    StatsbeatFeature[StatsbeatFeature["DISTRO"] = 8] = "DISTRO";
    StatsbeatFeature[StatsbeatFeature["LIVE_METRICS"] = 16] = "LIVE_METRICS";
    StatsbeatFeature[StatsbeatFeature["SHIM"] = 32] = "SHIM";
    StatsbeatFeature[StatsbeatFeature["CUSTOMER_SDKSTATS"] = 64] = "CUSTOMER_SDKSTATS";
    StatsbeatFeature[StatsbeatFeature["MULTI_IKEY"] = 128] = "MULTI_IKEY";
})(StatsbeatFeature || (exports.StatsbeatFeature = StatsbeatFeature = {}));
var StatsbeatInstrumentation;
(function (StatsbeatInstrumentation) {
    /** Azure Monitor Supported Instrumentations */
    StatsbeatInstrumentation[StatsbeatInstrumentation["NONE"] = 0] = "NONE";
    StatsbeatInstrumentation[StatsbeatInstrumentation["AZURE_CORE_TRACING"] = 1] = "AZURE_CORE_TRACING";
    StatsbeatInstrumentation[StatsbeatInstrumentation["MONGODB"] = 2] = "MONGODB";
    StatsbeatInstrumentation[StatsbeatInstrumentation["MYSQL"] = 4] = "MYSQL";
    StatsbeatInstrumentation[StatsbeatInstrumentation["REDIS"] = 8] = "REDIS";
    StatsbeatInstrumentation[StatsbeatInstrumentation["POSTGRES"] = 16] = "POSTGRES";
    StatsbeatInstrumentation[StatsbeatInstrumentation["BUNYAN"] = 32] = "BUNYAN";
    StatsbeatInstrumentation[StatsbeatInstrumentation["WINSTON"] = 64] = "WINSTON";
    /** OpenTelemetry Supported Instrumentations */
    // Console instrumentation is not supported here - occupies 128
    StatsbeatInstrumentation[StatsbeatInstrumentation["CUCUMBER"] = 256] = "CUCUMBER";
    StatsbeatInstrumentation[StatsbeatInstrumentation["DATALOADER"] = 512] = "DATALOADER";
    StatsbeatInstrumentation[StatsbeatInstrumentation["FS"] = 1024] = "FS";
    StatsbeatInstrumentation[StatsbeatInstrumentation["LRU_MEMOIZER"] = 2048] = "LRU_MEMOIZER";
    StatsbeatInstrumentation[StatsbeatInstrumentation["MONGOOSE"] = 4096] = "MONGOOSE";
    StatsbeatInstrumentation[StatsbeatInstrumentation["RUNTIME_NODE"] = 8192] = "RUNTIME_NODE";
    StatsbeatInstrumentation[StatsbeatInstrumentation["SOCKET_IO"] = 16384] = "SOCKET_IO";
    StatsbeatInstrumentation[StatsbeatInstrumentation["TEDIOUS"] = 32768] = "TEDIOUS";
    StatsbeatInstrumentation[StatsbeatInstrumentation["UNDICI"] = 65536] = "UNDICI";
    StatsbeatInstrumentation[StatsbeatInstrumentation["CASSANDRA"] = 131072] = "CASSANDRA";
    StatsbeatInstrumentation[StatsbeatInstrumentation["CONNECT"] = 262144] = "CONNECT";
    StatsbeatInstrumentation[StatsbeatInstrumentation["DNS"] = 524288] = "DNS";
    StatsbeatInstrumentation[StatsbeatInstrumentation["EXPRESS"] = 1048576] = "EXPRESS";
    StatsbeatInstrumentation[StatsbeatInstrumentation["FASTIFY"] = 2097152] = "FASTIFY";
    StatsbeatInstrumentation[StatsbeatInstrumentation["GENERIC_POOL"] = 4194304] = "GENERIC_POOL";
    StatsbeatInstrumentation[StatsbeatInstrumentation["GRAPHQL"] = 8388608] = "GRAPHQL";
    StatsbeatInstrumentation[StatsbeatInstrumentation["HAPI"] = 16777216] = "HAPI";
    StatsbeatInstrumentation[StatsbeatInstrumentation["IOREDIS"] = 33554432] = "IOREDIS";
    StatsbeatInstrumentation[StatsbeatInstrumentation["KNEX"] = 67108864] = "KNEX";
    StatsbeatInstrumentation[StatsbeatInstrumentation["KOA"] = 134217728] = "KOA";
    StatsbeatInstrumentation[StatsbeatInstrumentation["MEMCACHED"] = 268435456] = "MEMCACHED";
    StatsbeatInstrumentation[StatsbeatInstrumentation["MYSQL2"] = 536870912] = "MYSQL2";
    StatsbeatInstrumentation[StatsbeatInstrumentation["NESTJS_CORE"] = 1073741824] = "NESTJS_CORE";
    StatsbeatInstrumentation[StatsbeatInstrumentation["NET"] = 2147483648] = "NET";
    StatsbeatInstrumentation[StatsbeatInstrumentation["PINO"] = 4294967296] = "PINO";
    StatsbeatInstrumentation[StatsbeatInstrumentation["RESTIFY"] = 8589934592] = "RESTIFY";
    StatsbeatInstrumentation[StatsbeatInstrumentation["ROUTER"] = 17179869184] = "ROUTER";
    StatsbeatInstrumentation[StatsbeatInstrumentation["AMQPLIB"] = 34359738368] = "AMQPLIB";
})(StatsbeatInstrumentation || (exports.StatsbeatInstrumentation = StatsbeatInstrumentation = {}));
/**
 * Statsbeat Instrumentation Mapping
 * @internal
 */
exports.StatsbeatInstrumentationMap = new Map([
    ["@opentelemetry/instrumentation-amqplib", StatsbeatInstrumentation.AMQPLIB],
    ["@opentelemetry/instrumentation-cucumber", StatsbeatInstrumentation.CUCUMBER],
    ["@opentelemetry/instrumentation-dataloader", StatsbeatInstrumentation.DATALOADER],
    ["@opentelemetry/instrumentation-fs", StatsbeatInstrumentation.FS],
    ["@opentelemetry/instrumentation-lru-memoizer", StatsbeatInstrumentation.LRU_MEMOIZER],
    ["@opentelemetry/instrumentation-mongoose", StatsbeatInstrumentation.MONGOOSE],
    ["@opentelemetry/instrumentation-runtime-node", StatsbeatInstrumentation.RUNTIME_NODE],
    ["@opentelemetry/instrumentation-socket.io", StatsbeatInstrumentation.SOCKET_IO],
    ["@opentelemetry/instrumentation-tedious", StatsbeatInstrumentation.TEDIOUS],
    ["@opentelemetry/instrumentation-undici", StatsbeatInstrumentation.UNDICI],
    ["@opentelemetry/instrumentation-cassandra-driver", StatsbeatInstrumentation.CASSANDRA],
    ["@opentelemetry/instrumentation-connect", StatsbeatInstrumentation.CONNECT],
    ["@opentelemetry/instrumentation-dns", StatsbeatInstrumentation.DNS],
    ["@opentelemetry/instrumentation-express", StatsbeatInstrumentation.EXPRESS],
    ["@opentelemetry/instrumentation-fastify", StatsbeatInstrumentation.FASTIFY],
    ["@opentelemetry/instrumentation-generic-pool", StatsbeatInstrumentation.GENERIC_POOL],
    ["@opentelemetry/instrumentation-graphql", StatsbeatInstrumentation.GRAPHQL],
    ["@opentelemetry/instrumentation-hapi", StatsbeatInstrumentation.HAPI],
    ["@opentelemetry/instrumentation-ioredis", StatsbeatInstrumentation.IOREDIS],
    ["@opentelemetry/instrumentation-knex", StatsbeatInstrumentation.KNEX],
    ["@opentelemetry/instrumentation-koa", StatsbeatInstrumentation.KOA],
    ["@opentelemetry/instrumentation-memcached", StatsbeatInstrumentation.MEMCACHED],
    ["@opentelemetry/instrumentation-mysql2", StatsbeatInstrumentation.MYSQL2],
    ["@opentelemetry/instrumentation-nestjs-core", StatsbeatInstrumentation.NESTJS_CORE],
    ["@opentelemetry/instrumentation-net", StatsbeatInstrumentation.NET],
    ["@opentelemetry/instrumentation-pino", StatsbeatInstrumentation.PINO],
    ["@opentelemetry/instrumentation-restify", StatsbeatInstrumentation.RESTIFY],
    ["@opentelemetry/instrumentation-router", StatsbeatInstrumentation.ROUTER],
]);
//# sourceMappingURL=types.js.map